import VueCookie from "vue-cookie";
import { Toast } from "vant";
import router from "../router";
import store from "../store";
import { isIos, isAndroid } from "@/utils/utils.js";
import { K_PARAMS } from "@/utils/sensorParams.js";

//自定义不需要跳转全局登录页的路由
let defaultNot401Router = [
  "outside-signup",
  "outside-introduce",
  "outside-newsuccess",
  "ielts-webapp-videoClass",
  "ielts-webapp-leadStudy",
];
function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}
/**
 * 注册全局Axios拦截器
 */
// 进入页面,对url进行编码，防止浏览器拦截hash地址。
let originUrl = encodeURIComponent(window.location.href);
export function registerInterceptor(options) {
  // 添加通用header
  if (VueCookie.get("authkey")) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + VueCookie.get("authkey");
  } else {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + getQueryString("authorization");
  }
  // 埋点数据
  axios.defaults.headers.common["K-Product-Line"] = K_PARAMS["k-product-line"];
  axios.defaults.headers.common["K-Platform"] = K_PARAMS["k-platform"];
  // 添加请求拦截器
  axios.interceptors.request.use((config) => {
    return {
      // withCredentials:true,
      ...options,
      ...config,
    };
  });

  // 添加响应拦截器
  axios.interceptors.response.use(
    (res) => {
      const ret = res.data; // 响应成功后已经获取 res.data 这里需要注意下
      return Promise.resolve(ret);
    },
    (err) => {
      const status = (err.response && err.response.status) || "网络异常"; //  错误状态
      let message = "";
      switch (status) {
        case 404:
          message = "请求资源未找到";
          break;
        case 401:
          message = "身份过期";
          let activeRouteName = router.app.$route["name"];
          if (defaultNot401Router.includes(activeRouteName)) {
            if (
              activeRouteName == "outside-signup" ||
              activeRouteName == "outside-introduce"
            ) {
              Toast.fail(message);
              store.dispatch("outside_removeInfo");
              window.location.reload();
            }
            if (activeRouteName == "outside-newsuccess") {
              store.dispatch("outside_removeInfo");
              alert(message + ",请重新进入活动页面");
            }
            if (
              activeRouteName == "ielts-webapp-videoClass" ||
              activeRouteName == "ielts-webapp-leadStudy"
            ) {
              try {
                if (isIos()) {
                  window.webkit.messageHandlers.nativeLogin.postMessage(null);
                }
                if (isAndroid()) {
                  window.app.nativeLogin();
                }
              } catch (error) {
                Toast.fail("用户身份失效，请重新登陆!");
              }
            }
          } else {
            localStorage.removeItem("userInfo"); //  无权限 移除用户信息，代表认证过期或者未登录
            setTimeout(() => {
              // 处理登录失败，跳转到登录页
              window.location.replace(
                process.env.VUE_APP_PRFIEX +
                  "account.kmf.com/login?backurl=" +
                  originUrl,
                "_blank"
              );
            }, 1000);
          }

          break;
        case 500:
          message = "服务器异常";
          break;
        default:
          message = status;
          break;
      }
      //window.alert(message);
      Toast.fail(message);
      return Promise.reject(err);
    }
  );
}
